import instamapsHeader from './shared/components/header/header.vue';
import instamapsFooter from './shared/components/footer/footer.vue';
import instamapsLoader from './shared/components/loader/loader.vue';
import instamapsMapViewer from './map-viewer/map-viewer.vue';
import {LoginService} from './login/services/loginService';
import * as $ from 'jquery';

export default {
    name: 'visorApp',
    components: {
        instamapsHeader,
        instamapsMapViewer,
        instamapsFooter,
        instamapsLoader,
    },
    data() {
        return {
            isLoading: false,
            selectedLang: '',
            hasToShowMobileMenu: undefined,
            loaderTitle: undefined,
            loaderMessage: undefined,
            loaderIsStatic: false,
            loaderHasDismiss: false,
            loaderIsError: false,
			isUserLogged: false,
			logo: '',
			url: '',
			mapName: '',
            viewerParams: {},
            contact:'',
        };
    },
    computed: {
        isInIframe: function () {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        },
    },
    methods: {
        showLoader: function (ev) {
            if (ev && ev.title) { this.loaderTitle = ev.title; }
            if (ev && ev.message) { this.loaderMessage = ev.message; }
            (ev && ev.isStatic) ? this.loaderIsStatic = ev.isStatic: this.loaderIsStatic = false;
            (ev && ev.hasDismiss) ? this.loaderHasDismiss = ev.hasDismiss: this.loaderHasDismiss = false;
            (ev && ev.isError) ? this.loaderIsError = ev.isError: this.loaderIsError = false;
            this.isLoading = true;
        },
        hideLoader: function () {
            this.isLoading = false;
        },
        showMobileMenu: function (value) {
            this.hasToShowMobileMenu = value;
            (value) ? $('#app-container').removeClass('mobileMenuSlidingOut').addClass('mobileMenuSliding'): $('#app-container').removeClass('mobileMenuSliding').addClass('mobileMenuSlidingOut');
        },
        langChange: function (value) {
            this.$parent.$emit('langchanged', value);
            this.selectedLang = value;
        },
        hideLanguageSelector: function () {
            $('#language-selector').removeClass('show-language-menu');
        },
        userLogin: function (){
            this.isUserLogged= true;
            this.redirectProfile();
        },
        isLogged: function (){
            this.isUserLogged = LoginService.isUserLogged();
        },
        userLogout: function (){
            LoginService.httpPostLogout().then((response) => {
                if (response.status==="OK") {
                    this.isUserLogged = false;
                    this.redirectHome();
                }else{
                    this.isUserLogged = false;
                    this.redirectHome();
                }
            }).catch(() => {
                this.isUserLogged = false;
                this.redirectHome();
            });
        },
        redirectLogin: function (){
            this.redirect("/#/login");
            //this.$router.push('/login');
        },
        redirectProfile: function (){
            this.redirect("/#/perfil");
            //this.$router.push('/perfil');
        },
        redirectHome: function (){
            this.redirect("/");
            //this.$router.push('/');
        },
        redirect: function (path){
            window.location.href = path;
        },
    },
    mounted() {
		this.isLogged();
		this.$root.$on("logoChanged", data => {
			if(data !== "") {
				this.logo = data;
			}
		});
		this.$root.$on("mapNameChanged", data => {
			if(data !== "") {
				this.mapName = data;
			}
		});
		this.$root.$on("URLChanged", data => {
			if(data !== "" && data !== undefined) {

				if(data.match("^https?://") === null)
					this.url = "http://";
				
				this.url += data;
			}
        });
        this.$root.$on("mapNameChanged", data => {
            if(data !== "") {
                this.mapName = data;
            }
        });
		this.$root.$on("viewerParamsChanged", data => {
			if(data !== "") {
				this.viewerParams = data;
			}
		});

		/******** EASTER EGG ***********************************************/
		const millis = [500, 1810, 2220, 3200, 4090, 3290, 4050, 3290, 3990, 5870, 910, 1190, 2710, 1160, 1310, 2450, 110, 940, 2760, 2350, 1030, 600, 3270, 1010, 620, 1130, 2520, 590, 2790, 1540, 0, 0, 0, 0, 1000, 1000, 1000, 1000, 1000, 1000, 1000];
		const imageURL = 'https://betaserver.icgc.cat/InstamapsIsMade.jpg';
		const decodedString = b64DecodeUnicode("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");
		const songLines = decodedString.split("\n");
		const styles = {
			normalBig: "font-weight: normal; font-size: 18px",
			boldBig: "font-weight: bold; font-size: 18px",
			normal: "font-weight: normal",
			bold: "font-weight: bold",
			rebelLogo: "font-size:29px;background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4wMcDg4h2R9BoQAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAD1klEQVRYw8XXa6hUVRQH8N8er6Z2r1ip4xOk0ksjmhUq2YMKywxN6UFJKUqEPQljguhbkBY2UEQoWmAhYYVSilRQQmQpZYUV7jKyLDUcELQM07y5++DxMs6dO46PS38Yzjr7v9dee68z67E5A6RofIom+z+QouEp2pWiwymadLrr5E7TeE98hCHogZUpGlpjXrfT3kCKhqToyRT1rkG/iosq3vtheY15R1M0P0VjT/WEI1K0KUWFOnyq+t3cydxzUrQ2Rbc25IEUXYyIT0JBrOJeT9Hn2IMPKqiIzSlalqINKTr3OBEKDuMZrEnR7XU3kKJ+WIc2PFvFLcNsjMe32FZB/441uB9X481K3VDwRcavStG0eh54Aa14KRTsr+IWZoZhOB6s4K7DxEzejadqeHtR9lySogs6bCALpXuz1xertUPBDlyO9dlQjwq6CQG7cGUo+K6G/kb8iqO4q328Ilx2YCh2h0LHkKrYaCu+P65bhYmhYFOnugf0Di0Otr+X8qEpk2/DwEz+sV6EhIJtKVqL6VXUhnrGwdL8qFQyHxdiSyiWH8ilKIepmRvhrwYidUGNsRUN6E3HTEzAjFTKn5dDH05IFANOtkoo2FxjeGMDGxhdITdjTC4TRlQQE1Ks+X2r8U/2/BfzQ8HWBnSmVsi9MCSXub5X1cRHGljseBQstnT46vR8vqVudi3lZ1WFfe74BvrXmL8wRX3r1YlM/M37+ccN+3uj4Po6xlvwRA2qfw7daxDNeCXF9j9mNY4lmhZ3S17LwnduHQc8WvX9T3DDnk6U7sCKyryenX4yHtLdHG/l++GejJqRSvn7apy+lNWCWtgXUjQM2zvxBBzBEnyMKVkWm+LtITs0t32WpeX28ot3sRiXYT4G1/HMnJDl5U1VkVALh7DKJR62YNBgPY+urArfU8VBTM/hTzrm7grsxGO6aw0Fs5Tyc/U8+ukZGocD+KEpFBxJ0XpMymK6Db/gPd28EVr9lGa2dnfF/ktTyTtZQTob+DkUy7uOFaOt+uhmuAHK4XxlSFLw3KBrNaUbcRPGneW+dloolte1Z7y0aGB/uTQdY3ANRmZJqkcXNNU/hWJ5hOqSmkr57Vml6mqMC8Xyl7U6ojvxRxcbX46vT2hIqrwwL4v70AXGd2JkKJYPddoVh2J5Kebh8Fk2vhmjK42rd8pUyl+Vdch9z4LxdZgdiuV9HQ58khLahJW4hZo3pJNhL54OxfLLnTY3Dd2USvmxWXGaloVpPbThQ6zGmlAs763bXTV8XSvlQ5YXmnEDRmV3iG7Yh2/wFbYghWK5rZF1/wPfzzqe+rNYEQAAAABJRU5ErkJggg==');"
		}
		let index = 0;

		function b64DecodeUnicode(str) {
			return decodeURIComponent(atob(str).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		}

		function printNextLine() {

			index++;
			if(songLines[index-1][0] === '%')
				console.log(songLines[index-1], styles.bold, styles.normal);
			else
				console.log(songLines[index-1]);

			if(index < songLines.length) {
			
				setTimeout(() => {
					printNextLine();
				}, millis[index]);

			} else {

				easterHasFinished();

			}

		}

		function itsEaster() {

			const img = document.createElement("img");
			img.src = imageURL;
			img.id = "geostarters";
			img.style.cssText = "position: absolute;z-index: 10;top: calc(50vh - 384px);left: calc(50vw - 512px);";
			document.body.appendChild(img);

			index = 0;
			console.clear();
			console.log("It's easter!");
			setTimeout(() => { printNextLine() }, millis[index]);

		}

		function easterHasFinished() {

			console.log("\n\n\n\n\n");
			console.log("%c  %cInnovar %cés %crebel·lar-se %ccontra l'status quo", styles.rebelLogo, styles.boldBig, styles.normalBig, styles.boldBig, styles.normalBig);
			console.log("\n\n\n\n\n");
			console.log("%cGràcies per la companyia Geostarters! Seguiu %csomiant%c!", styles.normalBig, styles.boldBig, styles.normalBig);
			console.log("%cPixel Ninja", styles.bold);
			const img = document.getElementById("geostarters");
			document.body.removeChild(img);

		}

		if ( window.addEventListener ) {
			let kkeys = [], konami = "38,38,40,40,37,39,37,39,66,65";
			window.addEventListener("keydown", function(e){
				kkeys.push( e.keyCode );
				if ( kkeys.toString().indexOf( konami ) >= 0 ) {
					itsEaster();				
					kkeys = [];
				}
			}, true);
		}
		/******** EASTER EGG ***********************************************/
        this.$root.$on("contactChanged", data => {
			if(data !== "") {
				this.contact = data;
            }
            else this.contact = "instamaps@icgc.cat";
		});
    },
};



// WEBPACK FOOTER //
// ./src/App.js